import React from "react";
import styled from "styled-components";

import MUILink from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import { INFO_EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";

export const Link = styled(MUILink)`
  cursor: pointer;
  display: inline-block;
  text-decoration: underline !important;
  color: #007bff !important;
`;

export const FailureContainer = () => (
  <section>
    <Typography variant="h4" gutterBottom>
      Network Access Pending
    </Typography>
    <Typography paragraph>
      Thank you for registering for a RoomSync administrative site account. If you have just registered, our staff has
      been notified and will be giving you access to your community network soon. If you have questions or concerns,
      please email <Link href={`mailto:${INFO_EMAIL_ADDRESS}`}>{INFO_EMAIL_ADDRESS}</Link>. or call {PHONE_NUMBER}.
    </Typography>
  </section>
);

export const FAILURE_URL = "/failure";
